<div class="inventory-container">

  <!-- ACTION BUTTONS -->
  <div class="action-buttons">
    <button class="btn-add-inventory" (click)="openPurchaseOrder()">
      <i class="icon-plus"></i> Add Inventory
    </button>

    <button class="btn-clinic-supply" (click)="openClinicSupply()">
      <i class="icon-package"></i> Clinic Supply
    </button>
  </div>

  <div class="inventory-table-card">
    <p-table
      #dt
      [value]="medicines"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [rowsPerPageOptions]="[10,25,50]"
      [lazy]="true"
      sortMode="single"
      (onLazyLoad)="loadTable($event)"
      [rowHover]="true"
      styleClass="p-datatable-striped"
      [globalFilterFields]="['name','warehouse_stock.quantity','status']">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            MEDICINE
            <p-sortIcon field="name"></p-sortIcon>
          </th>

          <th pSortableColumn="warehouse_stock.quantity">
            QUANTITY
            <p-sortIcon field="warehouse_stock.quantity"></p-sortIcon>
          </th>

          <th>
            STATUS
            <!-- <p-sortIcon field="status"></p-sortIcon> -->
          </th>

          <th>ACTIONS</th>
        </tr>

        <!-- 🔥 Filter Row -->
        <tr>
          <!-- Medicine Search -->
          <th>
            <input pInputText placeholder="Search Name"
            (input)="applyFilter('name', $any($event.target).value)"
            class="w-100 p-inputtext-sm">
          </th>

          <!-- Quantity Filter -->
          <th>
            <input pInputText type="number" placeholder="Qty"
            (input)="applyFilter('quantity', $any($event.target).value)"
            class="w-100 p-inputtext-sm">
          </th>

          <!-- Status Filter -->
          <th>
            <!-- <input pInputText type="text" placeholder="Status"
            (input)="applyFilter('status', $any($event.target).value)"
            class="w-100 p-inputtext-sm"> -->
          </th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr class="inventory-table-body">
          <td>{{ item.name }}</td>

          <td>{{ item.warehouse_stock?.quantity ?? 0 }}</td>

          <td>
            <span class="status-badge" [ngClass]="getStatusClass(item?.warehouse_stock?.quantity)">
              {{ getStatus(item?.warehouse_stock?.quantity) }}
            </span>
          </td>

          <td>
            <button class="btn-history" (click)="openPoHistoryPopup(item)">
              <i class="pi pi-history"></i> History
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- MODALS ARE CLEANED + NO BROKEN REFERENCES -->

<!-- ================= PURCHASE ORDER MODAL ================= -->
<div class="modal-overlay" *ngIf="isPurchaseOrderVisible" (click)="closePurchaseOrder()">
  <div class="modal-dialog modal-large" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2>Add Inventory</h2>
      <button class="btn-close" (click)="closePurchaseOrder()"><i class="pi pi-times"></i></button>
    </div>

    <div class="modal-body">
      <div class="form-container">

        <div class="form-section d-flex">
          <div>
            <label><i class="icon-calendar"></i> Date</label>
            <input type="date" [(ngModel)]="purchaseOrder.date">
          </div>
        </div>

        <div class="form-section">
          <h3><i class="icon-box"></i> Products</h3>

          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <!-- <th>Price</th>
                <th>Total</th> -->
                <th></th>
              </tr>
            </thead>

            <tbody>
            <tr *ngFor="let row of purchaseItems; let i=index">

              <td>
                <select [(ngModel)]="row.medicine_id" (change)="calcPurchase(i)">
                  <option value="">Select</option>
                  <option *ngFor="let m of medicines" [value]="m.id">{{m.name}}</option>
                </select>
              </td>

              <td><input type="number" [(ngModel)]="row.qty" (input)="calcPurchase(i)"></td>

              <!-- <td><input type="number" [(ngModel)]="row.price" (input)="calcPurchase(i)"></td> -->

              <!-- <td><input type="number" [value]="row.total" readonly></td> -->

              <td><button (click)="removePurchaseRow(i)">🗑</button></td>

            </tr>
            </tbody>
          </table>

          <button (click)="addPurchaseRow()">+ Add Item</button>
          <!-- <h3>Total: ₹{{finalPurchaseTotal}}</h3> -->
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="status-badge status-in-stock" (click)="savePurchase()">Save</button>
    </div>
  </div>
</div>


<!-- ================= CLINIC SUPPLY MODAL ================= -->
<div class="modal-overlay" *ngIf="isClinicSupplyVisible" (click)="closeClinicSupply()">
  <div class="modal-dialog modal-large" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2>Clinic Supply</h2>
      <button class="btn-close" (click)="closeClinicSupply()"><i class="pi pi-times"></i></button>
    </div>

    <div class="modal-body">
      <div class="form-container">

        <div class="form-section d-flex gap-3">
          <div>
            <label><i class="icon-calendar"></i> Date</label>
            <input type="date" [(ngModel)]="clinicSupply.date">
          </div>

          <div>
            <label><i class="icon-hospital"></i> Clinic</label>
            <select [(ngModel)]="clinicSupply.clinic_id">
              <option value="">Select Clinic</option>
              <option *ngFor="let c of clinics" [value]="c.id">{{c.name}}</option>
            </select>
          </div>
        </div>

        <div class="form-section">
          <h3><i class="icon-box"></i> Products</h3>

          <table>
            <thead><tr><th>Item</th><th>Qty</th><th></th></tr></thead>

            <tbody>
            <tr *ngFor="let row of clinicRows; let i=index">

              <td>
                <select [(ngModel)]="row.medicine_id">
                  <option value="">Select</option>
                  <option *ngFor="let m of medicines" [value]="m.id">{{m.name}}</option>
                </select>
              </td>

              <td>
                <input type="number" [(ngModel)]="row.qty" [max]="getAvailableQty(row.medicine_id)">
              </td>

              <td><button (click)="removeSupplyRow(i)">🗑</button></td>

            </tr>
            </tbody>
          </table>

          <button (click)="addSupplyRow()">+ Add Item</button>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-success" (click)="supplyToClinic()">Supply</button>
    </div>
  </div>
</div>


<!-- ================= HISTORY MODAL ================= -->
<div class="modal-overlay" *ngIf="isHistoryPopupVisible" (click)="closeHistoryPopup()">
  <div class="modal-dialog modal-large" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2 *ngIf="selectedItem">Transaction History: <i>{{selectedItem.name}}</i></h2>
      <!-- <h5 *ngIf="selectedItem">{{selectedItem.name}}</h5> -->
      <button (click)="closeHistoryPopup()" class="btn-close"><i class="pi pi-times"></i></button>
    </div>

    <div class="modal-body">
      <table *ngIf="history.length>0">

        <thead>
        <tr><th>Date</th><th>Action</th><th>Location</th><th>Old</th><th>Change</th><th>Total</th></tr>
        </thead>

        <tbody>
        <tr *ngFor="let h of history">
          <td>{{h.created_at|date}}</td>
          <td>{{h.action}}</td>
          <td>{{h.location}}</td>
          <td>{{h.old_quantity}}</td>
          <td [style.color]="h.change_quantity>0?'green':'red'">{{h.change_quantity}}</td>
          <td>{{h.total_quantity}}</td>
        </tr>
        </tbody>

      </table>

      <p *ngIf="history.length==0" style="text-align:center;">No history available</p>
    </div>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeHistoryPopup()">Close</button>
    </div>
  </div>
</div>
